<div class="card">
  <app-header titulo="Widget" [descricao]="edicao ? 'Edição de widget' : 'Cadastro de widget'"></app-header>

  <p-message *ngIf="acessoNegado; else formulario" severity="warn" text="Acesso restrito a administradores" styleClass="w-full justify-content-start" />

  <ng-template #formulario>
    <div class="grid">
      <div class="col-12 lg:col-8">
        <div class="field">
          <label for="modulo">Módulo:</label>
          <p-treeSelect #seletorModulo inputId="modulo" [(ngModel)]="moduloSelecionado" [options]="modulos" (onNodeSelect)="aoSelecionarModulo($event.node)"
            [filter]="true" filterBy="label" selectionMode="single" placeholder="Selecione um módulo"
            [disabled]="carregandoModulos" containerStyleClass="w-full" appendTo="body" />
          <small class="p-error block" *ngIf="enviado && !widget.moduloId">Módulo é obrigatório.</small>
        </div>

        <div class="field">
          <label for="identificador">Identificador:</label>
          <input id="identificador" pInputText type="text" [(ngModel)]="widget.identificador" class="w-full font-monospace"
            [readonly]="edicao" [class.p-disabled]="edicao" (blur)="validarIdentificador()" (input)="erroIdentificador = null"
            placeholder="modulo.nome-exclusivo" autocomplete="off" />
          <small class="block text-color-secondary mt-1" *ngIf="!edicao">
            Formato <code>modulo.nome-exclusivo</code>: nome do módulo sem <code>ROLE_</code>, em minúsculas e com <code>_</code> trocado por <code>-</code>
            (ex.: <code>integ-movimen-notafis.pendentes</code>). Deve ser igual à chave do componente no frontend.
          </small>
          <small class="block text-color-secondary mt-1" *ngIf="edicao">O identificador não pode ser alterado após a criação.</small>
          <small class="block text-color-secondary" *ngIf="validandoIdentificador"><i class="pi pi-spin pi-spinner text-xs"></i> Validando...</small>
          <small class="p-error block" *ngIf="erroIdentificador">{{ erroIdentificador }}</small>
          <small class="p-error block" *ngIf="enviado && !erroIdentificador && (!widget.identificador.trim() || widget.identificador.trim().endsWith('.'))">
            Identificador é obrigatório.
          </small>
        </div>

        <div class="field">
          <label for="nome">Nome:</label>
          <input id="nome" pInputText type="text" [(ngModel)]="widget.nome" class="w-full" maxlength="255" />
          <small class="p-error block" *ngIf="enviado && !widget.nome.trim()">Nome é obrigatório.</small>
        </div>

        <div class="field">
          <label for="descricao">Descrição:</label>
          <textarea id="descricao" pInputTextarea [(ngModel)]="widget.descricao" rows="3" class="w-full" [autoResize]="true"></textarea>
          <small class="p-error block" *ngIf="enviado && !widget.descricao.trim()">Descrição é obrigatória.</small>
        </div>

        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="icone">Ícone:</label>
            <div class="flex gap-2 align-items-center">
              <input id="icone" pInputText type="text" [(ngModel)]="widget.icone" class="w-full" placeholder="pi pi-chart-bar" autocomplete="off" />
              <span class="preview-icone"><i [class]="widget.icone || 'pi pi-image'" [class.text-color-secondary]="!widget.icone"></i></span>
            </div>
            <small class="block text-color-secondary mt-1">Classe CSS (PrimeIcons, Material...). Opcional.</small>
          </div>

          <div class="field col-12 md:col-6">
            <label for="ativo">Ativo:</label>
            <div class="flex gap-2 align-items-center">
              <p-inputSwitch inputId="ativo" [(ngModel)]="widget.ativo" />
              <span class="text-color-secondary">{{ widget.ativo ? 'Disponível para os usuários' : 'Oculto (somente admin vê)' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-4">
        <div class="formgrid grid">
          <div class="field col-6">
            <label for="largura">Largura (colunas):</label>
            <p-dropdown inputId="largura" [options]="larguras" [(ngModel)]="widget.largura" styleClass="w-full" />
          </div>
          <div class="field col-6">
            <label for="altura">Altura (linhas):</label>
            <p-dropdown inputId="altura" [options]="alturas" [(ngModel)]="widget.altura" styleClass="w-full" />
          </div>
        </div>

        <label class="block mb-2">Pré-visualização do tamanho:</label>
        <div class="preview-grade" [attr.aria-label]="widget.largura + ' × ' + widget.altura">
          <span *ngFor="let celula of celulasPreview" [class.ocupada]="ocupada(celula)"></span>
        </div>
        <small class="block text-color-secondary mt-2">
          {{ widget.largura }} × {{ widget.altura }} de uma grade com 4 colunas.
        </small>
      </div>
    </div>

    <div class="flex gap-2 pt-3">
      <button pButton icon="pi pi-save" class="p-button-success" [label]="edicao ? 'Atualizar' : 'Salvar'" [loading]="salvando"
        (click)="salvar()"></button>
      <button pButton icon="pi pi-arrow-left" class="p-button-text" label="Voltar" (click)="voltar()"></button>
    </div>
  </ng-template>

  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
